import { render, staticRenderFns } from "./VouchersModal.vue?vue&type=template&id=039043ff&"
import script from "./VouchersModal.vue?vue&type=script&lang=js&"
export * from "./VouchersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports